import React, {
  useEffect,
  useCallback,
  useState,
  useMemo,
  useLayoutEffect,
} from "react";

import {
  useLocation,
  useHistory,
  useRouteMatch,
  useParams,
} from "react-router-dom";
import Request from "@/networkReq/request";
import Http from "@/networkReq/http";

import _ from "lodash";

import {
  DatePicker,
  Card,
  Select,
  Form,
  Tag,
  Upload,
  Button,
  Input,
  Col,
  Row,
  message,
} from "antd";
import Cascader from "@/components/Cascader";
import moment from "moment";
import { PlusOutlined } from "@ant-design/icons";
// import "../index.scss";
import { getToken } from "utils/storage";
import "./index.scss";
import { getDict } from "utils/storage";
import { dataSource1, formConfig, formConfig1 } from "./fieldConfig";
import uploadIcon from "../../img/userCenter/icon_upload_img.png";
import cancelIcon from "../../img/userCenter/icon_cancel.png";
const token = getToken();
const ImgUrl =
  "https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fseopic.699pic.com%2Fphoto%2F50079%2F1323.jpg_wh1200.jpg&refer=http%3A%2F%2Fseopic.699pic.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1659247127&t=b042f7d2b12955d415c7a86b7fa881b6";

const getBase64 = (img, callback) => {
  const reader = new FileReader();
  reader.addEventListener("load", () => callback(reader.result));
  reader.readAsDataURL(img);
};

const dictList = getDict();

const beforeUpload = (file) => {
  const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
  if (!isJpgOrPng) {
    message.error("只能上传格式为JPG/PNG文件");
  }
  const isLt2M = file.size / 1024 / 1024 < 2;
  if (!isLt2M) {
    message.error("图片大小不能超过2MB");
  }
  return isJpgOrPng && isLt2M;
};

const uploadProps = {
  maxCount: 1,
  listType: "picture-card",
  name: "file",
  className: "avatar-uploader",
  showUploadList: false,
  action: "/tyjrmh/api/blade-file/fileServer/uploadSingle",
  headers: {
    Authorization: "Basic c3dvcmQ6c3dvcmRfc2VjcmV0",
    "Blade-Auth": getToken(),
  },
  beforeUpload,
};

// const uploadButton = (
//   <div>
//     <PlusOutlined />
//     <div style={{ marginTop: 8 }}>上传图片</div>
//   </div>
// );

export default function SkillsTrainingApply(props) {
  const [form] = Form.useForm();
  const [dataSource, setDataSource] = useState([]);
  const [auditTrainType, setAuditTrainType] = useState(0);
  const [auditTrainState, setAuditTrainState] = useState(0); //0 未上传,审核中   1 审核通过   2 审核失败
  const [cardSquare, setCardSquare] = useState(""); // 身份证正面 上传的文件列表
  const [cardBack, setCardBack] = useState(""); // 身份证反面 上传的文件列表
  const [houseCardHome, setHouseCardHome] = useState(""); // 户口簿首页 上传的文件列表
  const [houseCardMyself, setHouseCardMyself] = useState(""); // 户口簿个人页 上传的文件列表
  const [photoManageList, setPhotoManageList] = useState([]); // 退役证 上传的文件列表
  const [socialCredit, setSocialCredit] = useState(""); //营业执照
  const [auditTrainRetireDate, setAuditTrainRetireDate] = useState(""); //退役时间
  const [auditTrainAddress, setAuditTrainAddress] = useState(""); //安置地
  const [loading, setLoading] = useState(false);
  // const { state: { isView } } = useLocation();
  const history = useHistory();
  const match = useRouteMatch();
  // const { id } = useParams();
  // let location = useLocation();
  // let query = location.query;
  let type = match.params.type;

  window.scrollTo(0, 0);

  useEffect(() => {
    // console.info("type==" + type);
    setAuditTrainType(type);
  }, [type]);

  const getcodelist = (codeList, code) => {
    return (
      codeList &&
      codeList.map((option) => {
        if (code) {
          if (option.code == code) {
            return (
              option.children &&
              option.children.map((item) => {
                return (
                  <Select.Option key={item.dictKey} value={item.dictKey}>
                    {item.dictValue}
                  </Select.Option>
                );
              })
            );
          }
        }
      })
    );
  };

  // 根据字典好
  const getcodeNames = (code, selectVal = []) => {
    let nameArr = [];
    console.log(selectVal);
    if (selectVal.length == 0) {
      return "";
    }
    dictList &&
      dictList.map((option) => {
        if (code) {
          if (option.code == code) {
            option.children &&
              option.children.forEach((item) => {
                selectVal.forEach((m) => {
                  if (item.dictKey == m) {
                    nameArr.push(item.dictValue);
                  }
                });
              });
          }
        }
      });
    return nameArr.join(",");
  };

  // 多选限制
  const handleMultiple = (rule, value, callback) => {
    if (value.length > 2) {
      message.error("最多选两个");
      form.setFieldsValue({
        auditTrainIntention: _.take(value, 2),
      });
      callback("最多选两个");
    } else {
      callback();
    }
  };

  const handleChange = (value, key) => {
    switch (key) {
      case "auditTrainRetireDate": // 退役日期
        let date = moment(value).format("YYYY-MM-DD");
        setAuditTrainRetireDate(date);
        break;
      case "auditTrainAddress": // 安置地址
        handleChangeAddress(value);
        break;

      default:
        break;
    }
  };

  // 安置地址格式化
  const handleChangeAddress = useCallback((e, name) => {
    console.log("useCallback", e, name);
    let v = "";
    if (e.countyName) {
      v = `${e.provinceName},${e.cityName},${e.countyName}`;
    } else if (e.cityName) {
      v = `${e.provinceName},${e.cityName}`;
    } else if (e.cityName) {
      v = `${e.provinceName}`;
    }
    console.log(name, v);
    setAuditTrainAddress(v);
  }, []);

  const delImg = (type) => {
    console.log("typetype", type);

    switch (type) {
      case "cardSquare":
        setCardSquare("");
        break;
      case "cardBack":
        setCardBack("");
        break;
      case "houseCardMyself":
        setHouseCardMyself("");
        break;
      case "houseCardHome":
        setHouseCardHome("");
        break;
      case "socialCredit":
        setSocialCredit("");
        break;
      default:
        // let newPhotoManageList =photoManageList.splice(type, 1)
        let newPhotoManageList = [];
        photoManageList.map((item, index) => {
          console.log(item, index);
          if (index != type) {
            newPhotoManageList.push(item);
          }
        });

        // console.log("newPhotoManageList", newPhotoManageList);
        setPhotoManageList([...newPhotoManageList]);

        break;
    }

    console.log("delImg", type, photoManageList);
  };

  const handleSubmit = () => {
    let getValue = {};
    form
      .validateFields()
      .then((values) => {
        getValue = JSON.parse(JSON.stringify(values));
        getValue.auditTrainIntention = getcodeNames(
          "industry_code",
          getValue.auditTrainIntention
        );
        getValue.auditTrainRetireDate = moment(
          getValue.auditTrainRetireDate
        ).format("YYYY-MM-DD");
        console.log("getValuegetValue111", getValue);
        let businessLicenseList = [];
        if (socialCredit) {
          businessLicenseList.push({
            photoUrl: socialCredit,
          });
        }
        const params = {
          ...dataSource1(),
          ...getValue,
          // auditTrainRetireDate,
          auditTrainAddress,
          auditTrainType,
          cardSquare,
          cardBack,
          houseCardHome,
          houseCardMyself,
          photoManageList,
          businessLicenseList,
        };
        console.log(params);
        // return;
        Http.post(Request.recordAdd(), params, (obj) => {
          if (obj.code == 200) {
            message.success("申请成功");
            console.log(obj);
            history.push("/home");
          }
        });
      })
      .catch((errorInfo) => {
        // console.log(errorInfo);
        message.error("请填写信息");
      });
  };

  const handleUpload = useCallback((info, type) => {
    console.log("info, type", info, type);

    let { file, fileList } = info;
    let imgUrl = "";
    if (file.status === "uploading") {
      setLoading(true);
    }
    if (file.status === "error") {
      message.error("上传失败");
      setLoading(false);
    }
    if (file.status === "done") {
      message.success("上传成功");
      setLoading(false);
      // imgUrl = ImgUrl
      //当图片上传完成，将保存的图片url写入到resData中
      // let resumePhoto = info.file.response.data.url
      // this.setState({ resData: { ...resData, resumePhoto } })
      getBase64(info.file.originFileObj, (url) => {
        // console.log('getBase64', url);
        // this.setState({ loading: false, imageUrl: url })
      });

      file.response && file.response.data && (imgUrl = file.response.data.url);
      console.log("handleUpload", imgUrl, file?.response?.data?.url, fileList);
      // fileList = fileList.filter((item) => item.status !== "error");
      // fileList.forEach(item => {
      //   item.response && item.response.data && (item.response.data.url = imgUrl)
      // })

      console.log("newPhotoManageList", photoManageList);
      switch (type) {
        case "cardSquare":
          setCardSquare(imgUrl);
          break;
        case "cardBack":
          setCardBack(imgUrl);
          break;
        case "photoManageList":
          let newPhotoManageList = photoManageList;
          console.log("newPhotoManageList1", newPhotoManageList);

          newPhotoManageList.push({ photoUrl: imgUrl });
          setPhotoManageList([...newPhotoManageList]);
          console.log("newPhotoManageList2", newPhotoManageList);

          break;
        case "houseCardMyself":
          setHouseCardMyself(imgUrl);
          break;
        case "houseCardHome":
          setHouseCardHome(imgUrl);
          break;
        case "socialCredit":
          setSocialCredit(imgUrl);
          break;
        default:
          break;
      }
    }
  });

  const applyTag = useMemo(() => {
    switch (auditTrainState) {
      case 0:
        return (
          <Tag color="#3356C5" className="apply_train_records_tag tag_loading">
            审核中
          </Tag>
        );
      case 1:
        return (
          <Tag color="#0FC73E" className="apply_train_records_tag tag_pass">
            审核通过
          </Tag>
        );
      case 2:
        return (
          <Tag color="#DD0B0B" className="apply_train_records_tag tag_fail">
            审核失败
          </Tag>
        );
      default:
        return <></>;
    }
  }, [auditTrainState]);

  console.info(auditTrainType);
  const layout = {
    wrapperCol: { span: 16 },
    labelCol: { span: 8 },
  };
  return (
    <div className="skills_training_apply">
      <div className="Base_Detils_Box">
        <span>当前位置：首页 / </span>
        {/* <span style={{ color: "#3356C5" }}> 技能培训申请-承诺书</span> */}
        <span style={{ color: "#3356C5" }}> 技能培训</span>
      </div>
      <div className="backBtn" onClick={() => history.goBack()}>
        返回
      </div>
      <div>
        <div className="page_title">
          {auditTrainType == 1 ? "异地" : "本地"}技能培训申请
        </div>
        <section>
          <div className="form_title">填写基本信息</div>
          <Form form={form} className="form_box" colon={false}>
            <Row
              gutter={[0, 16]}
              wrap
              style={{ width: "100%" }}
              justify="space-between"
            >
              {(auditTrainType == 1 ? formConfig1 : formConfig).map(
                (item, index) => {
                  if (item.type == "select") {
                    return (
                      <Col
                        key={index}
                        span={[10, 48]}
                        style={{ display: "flex", justifyContent: "end" }}
                      >
                        <Form.Item
                          name={item.name}
                          className={`form_item_label_background`}
                          rules={[
                            {
                              required: true,
                              message: `请选择${item.label}`,
                              validator:
                                item.mode == "multiple" ? handleMultiple : "",
                            },
                          ]}
                          label={
                            <span className={`form_item_label`}>
                              {item.label}:
                            </span>
                          }
                          {...layout}
                        >
                          <Select
                            mode={item.mode ? item.mode : ""}
                            default-value={item.mode == "multiple" ? [] : ""}
                            className="form_item_input"
                            placeholder={item.placeholder}
                            allowClear={true}
                            style={{ width: "294px" }}
                            disabled={item.disabled}
                            onChange={(e) => {
                              handleChange(e, item.name);
                            }}
                          >
                            {getcodelist(dictList, item.code)}
                          </Select>
                        </Form.Item>
                      </Col>
                    );
                  } else if (item.type == "area") {
                    return (
                      <Col
                        key={index}
                        span={[10, 48]}
                        style={
                          (index + 1) % 2 === 0
                            ? { display: "flex", justifyContent: "end" }
                            : {}
                        }
                      >
                        <Form.Item
                          name={item.name}
                          className={`form_item_label_background`}
                          rules={[
                            { required: true, message: `请选择${item.label}` },
                          ]}
                          label={
                            <span className={`form_item_label`}>
                              {item.label}:
                            </span>
                          }
                          {...layout}
                        >
                          <Cascader
                            className="form_cascader_box"
                            bespread={true}
                            onChange={(e) => {
                              handleChange(e, item.name);
                            }}
                          ></Cascader>
                        </Form.Item>
                      </Col>
                    );
                  } else if (item.type == "time") {
                    return (
                      <Col
                        key={index}
                        span={[10, 48]}
                        style={
                          (index + 1) % 2 === 0
                            ? { display: "flex", justifyContent: "end" }
                            : {}
                        }
                      >
                        <Form.Item
                          name={item.name}
                          className={`form_item_label_background`}
                          rules={[
                            { required: true, message: `请选择${item.label}` },
                            {
                              validator: item.validator,
                            },
                          ]}
                          label={
                            <span className={`form_item_label`}>
                              {item.label}:
                            </span>
                          }
                          {...layout}
                        >
                          <DatePicker
                            placeholder="选择日期"
                            onChange={(e) => {
                              handleChange(e, item.name);
                            }}
                          />
                        </Form.Item>
                      </Col>
                    );
                  } else {
                    return (
                      <Col
                        key={index}
                        span={[10, 48]}
                        style={
                          (index + 1) % 2 === 0
                            ? { display: "flex", justifyContent: "end" }
                            : {}
                        }
                      >
                        <Form.Item
                          name={item.name}
                          className={`form_item_label_background`}
                          rules={[
                            { required: true, message: `请填写${item.label}` },
                            {
                              pattern: item.pattern,
                              message: item.errorMsg
                                ? item.errorMsg
                                : `请输入正确的${item.label}`,
                            },
                          ]}
                          label={
                            <span className={`form_item_label`}>
                              {item.label}:
                            </span>
                          }
                          {...layout}
                        >
                          <Input
                            className="form_item_input"
                            type={item.type ? item.type : ""}
                          />
                        </Form.Item>
                      </Col>
                    );
                  }
                }
              )}
            </Row>
          </Form>
        </section>
        <section>
          <div className="form_title">身份证</div>
          <Form layout="inline" form={form} className="form_box" colon={false}>
            <Form.Item label="身份证正面">
              {cardSquare ? (
                <div className="idCard_img">
                  <img src={cardSquare} alt="" />
                  <span
                    className="del_img_btn"
                    onClick={() => delImg("cardSquare")}
                  >
                    <img src={cancelIcon} alt="" />
                  </span>
                </div>
              ) : (
                <Upload
                  {...uploadProps}
                  onChange={(info) => {
                    handleUpload(info, "cardSquare");
                  }}
                >
                  <div className="upload_materi">
                    <div className="upload_img">
                      <img src={uploadIcon} alt="" />
                      <span className="">点击上传</span>
                    </div>
                  </div>
                </Upload>
              )}
            </Form.Item>
            <Form.Item label="身份证反面">
              {cardBack ? (
                <div className="idCard_img">
                  <img src={cardBack} alt="" />
                  <span
                    className="del_img_btn"
                    onClick={() => delImg("cardBack")}
                  >
                    <img src={cancelIcon} alt="" />
                  </span>
                </div>
              ) : (
                <Upload
                  {...uploadProps}
                  onChange={(info) => {
                    handleUpload(info, "cardBack");
                  }}
                >
                  <div className="upload_materi">
                    <div className="upload_img">
                      <img src={uploadIcon} alt="" />
                      <span className="">点击上传</span>
                    </div>
                  </div>
                </Upload>
              )}
            </Form.Item>
          </Form>
        </section>
        <section>
          <div className="form_title">户口簿</div>
          <Form layout="inline" form={form} className="form_box" colon={false}>
            <Form.Item label="户口簿首页">
              {houseCardHome ? (
                <div className="idCard_img">
                  <img src={houseCardHome} alt="" />
                  <span
                    className="del_img_btn"
                    onClick={() => delImg("houseCardHome")}
                  >
                    <img src={cancelIcon} alt="" />
                  </span>
                </div>
              ) : (
                <Upload
                  {...uploadProps}
                  onChange={(info) => {
                    handleUpload(info, "houseCardHome");
                  }}
                >
                  <div className="upload_materi">
                    <div className="upload_img">
                      <img src={uploadIcon} alt="" />
                      <span className="">点击上传</span>
                    </div>
                  </div>
                </Upload>
              )}
            </Form.Item>
            <Form.Item label="户口簿个人页">
              {houseCardMyself ? (
                <div className="idCard_img">
                  <img src={houseCardMyself} alt="" />
                  <span
                    className="del_img_btn"
                    onClick={() => delImg("houseCardMyself")}
                  >
                    <img src={cancelIcon} alt="" />
                  </span>
                </div>
              ) : (
                <Upload
                  {...uploadProps}
                  onChange={(info) => {
                    handleUpload(info, "houseCardMyself");
                  }}
                >
                  <div className="upload_materi">
                    <div className="upload_img">
                      <img src={uploadIcon} alt="" />
                      <span className="">点击上传</span>
                    </div>
                  </div>
                </Upload>
              )}
            </Form.Item>
          </Form>
        </section>
        <section>
          <div className="form_title">退役证</div>
          <Form
            layout="inline"
            form={form}
            className="form_box form_box_retire"
            colon={false}
          >
            <Form.Item label="退役证">
              {photoManageList.length > 0 &&
                photoManageList.map((item, index) => (
                  <div className="idCard_img">
                    <img src={item.photoUrl} alt="" />
                    <span className="del_img_btn" onClick={() => delImg(index)}>
                      <img src={cancelIcon} alt="" />
                    </span>
                  </div>
                ))}
              {photoManageList.length < 5 && (
                <Upload
                  {...uploadProps}
                  onChange={(info) => {
                    handleUpload(info, "photoManageList");
                  }}
                >
                  <div className="upload_materi">
                    <div className="upload_img">
                      <img src={uploadIcon} alt="" />
                      <span className="">点击上传</span>
                    </div>
                  </div>
                </Upload>
              )}
            </Form.Item>
          </Form>
        </section>
        {auditTrainType == 1 && (
          <section>
            <div className="form_title">
              培训机构信息(培训机构统一社会信用代码照)
            </div>
            <Form
              layout="inline"
              form={form}
              className="form_box form_box_retire"
              colon={false}
            >
              <Form.Item label="营业执照">
                {socialCredit ? (
                  <div className="idCard_img">
                    <img src={socialCredit} alt="" />
                    <span
                      className="del_img_btn"
                      onClick={() => delImg("socialCredit")}
                    >
                      <img src={cancelIcon} alt="" />
                    </span>
                  </div>
                ) : (
                  <Upload
                    {...uploadProps}
                    onChange={(info) => {
                      handleUpload(info, "socialCredit");
                    }}
                  >
                    <div className="upload_materi">
                      <div className="upload_img">
                        <img src={uploadIcon} alt="" />
                        <span className="">点击上传</span>
                      </div>
                    </div>
                  </Upload>
                )}
              </Form.Item>
            </Form>
          </section>
        )}
      </div>
      <div className="form_box_footer">
        <Button
          type="default"
          className="btn_reset"
          onClick={() => history.goBack()}
        >
          取消
        </Button>
        <Button type="primary" className="btn_submit" onClick={handleSubmit}>
          提交
        </Button>
      </div>
    </div>
  );
}
